import React, { useEffect, useState } from 'react';
import { CheckCircle2, X } from 'lucide-react';
const NAMES = ['María L.', 'Juan P.', 'Sofía M.', 'Lucas R.', 'Valentina G.', 'Martín S.', 'Lucía B.', 'Diego F.', 'Camila T.', 'Nicolás A.'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén', 'Bariloche'];
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 5000);
    const showNotification = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setData({
        name: randomName,
        city: randomCity
      });
      setVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setVisible(false);
        // Schedule next notification
        setTimeout(showNotification, Math.random() * 15000 + 10000); // Random delay between 10-25s
      }, 4000);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-in slide-in-from-bottom-5 fade-in duration-500 font-['Inter']" data-id="element-9">
      <div className="bg-white rounded-lg shadow-2xl border-l-4 border-[#2D5A27] p-4 max-w-xs flex items-start gap-3 relative" data-id="element-10">
        <button onClick={() => setVisible(false)} className="absolute top-1 right-1 text-gray-400 hover:text-[#2D5A27] transition-colors" data-id="element-11">
          <X className="w-3 h-3" data-id="element-12" />
        </button>

        <div className="bg-[#2D5A27]/10 p-2 rounded-full flex-shrink-0 border border-[#2D5A27]/20" data-id="element-13">
          <CheckCircle2 className="w-5 h-5 text-[#2D5A27]" data-id="element-14" />
        </div>

        <div data-id="element-15">
          <p className="text-xs text-[#2D5A27] font-bold uppercase tracking-wide" data-id="element-16">
            Nueva compra
          </p>
          <p className="text-sm text-[#333333] font-medium" data-id="element-17">
            <span className="font-bold" data-id="element-18">{data.name}</span> de {data.city}
          </p>
          <p className="text-xs text-gray-500 mt-0.5" data-id="element-19">
            Compró "Manual de Cultivo"
          </p>
        </div>
      </div>
    </div>;
}